import { render, staticRenderFns } from "./RelatoriosPadroes.vue?vue&type=template&id=1927a2e8"
import script from "./RelatoriosPadroes.vue?vue&type=script&lang=js"
export * from "./RelatoriosPadroes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports